import firebase from 'firebase/app';
import 'firebase/messaging';

const normalConfig = {
  apiKey: 'AIzaSyAYIhRAV-sytvWujn_GG73qR2LFctsYnEI',
  authDomain: 'oq20-139d9.firebaseapp.com',
  databaseURL: 'https://oq20-139d9.firebaseio.com',
  projectId: 'oq20-139d9',
  storageBucket: 'oq20-139d9.appspot.com',
  messagingSenderId: '704244044101',
  appId: '1:704244044101:web:cb886ef81cdcd2e548ee2c',
};

// Api de Homologação

const homApiConfig = {
  apiKey: 'AIzaSyATjqL1cAnThrLhQ6YAv3MUx8CWTiEvan4',
  authDomain: 'oqhomapi.firebaseapp.com',
  databaseURL: 'https://oqhomapi.firebaseio.com',
  projectId: 'oqhomapi',
  storageBucket: 'oqhomapi.appspot.com',
  messagingSenderId: '565668799670',
  appId: '1:565668799670:web:a36f4778fb16ba236a3217',
};

let config = normalConfig;

if (
  process.env.NODE_ENV === 'production' &&
  (window.location.hostname === 'oqpwahom.firebaseapp.com' ||
    window.location.hostname === 'oqpwahom.web.app')
) {
  config = homApiConfig;
} else if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  config = homApiConfig;
}

let response: firebase.app.App | undefined;

if (!firebase.apps.length) {
  response = firebase.initializeApp(config);
}

let messaging = null;
if (firebase.messaging.isSupported()) {
  console.log('suported is firebase messaging');
  try {
    messaging = firebase.messaging();
  } catch (error) {
    console.log('suported messaging but error: ', error);
    throw error;
  }
} else {
  console.log('not suported is firebase messaging');
}

export { messaging };
